module.exports = __webpack_public_path__ + "img/tuvalu.f026a0a.webp";